import React, { useEffect } from 'react';
import KeywordInput from '../KeywordInput/KeywordInput';
import './TopicDialog.scss';

/**
 * 会話中に話題を入れ直すポップアップ。
 *
 * 中身は初回のお題入力（KeywordInput）をそのまま使う。
 * 「お題を入れる画面」が2種類あると覚え直しになるため、見た目を揃えている。
 *
 * これが開いている間、呼び出し側は一時停止状態にしておくこと
 * （会話・音声・BGM・アニメーションがまとめて止まる）。
 */
const TopicDialog = ({ onSubmit, onCancel }) => {
  // Esc で閉じる。モーダルの慣習に合わせる
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') onCancel();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onCancel]);

  // 背景を押したら閉じる。mousedown で判定しているのは、入力欄から
  // 文字を選択したまま外でボタンを離したときに閉じてしまうのを防ぐため
  const handleBackdrop = (e) => {
    if (e.target === e.currentTarget) onCancel();
  };

  return (
    <div
      className="topic-dialog"
      role="dialog"
      aria-modal="true"
      aria-label="話題を変える"
      onMouseDown={handleBackdrop}
    >
      <KeywordInput
        onSubmit={onSubmit}
        onCancel={onCancel}
        submitLabel="この話題にする ▸"
      />
    </div>
  );
};

export default TopicDialog;
